module.exports = __webpack_public_path__ + "static/media/sadbops.b89e2541.jfif";